import { h, Host } from "@stencil/core";
import { initMyTrumpfNotificationBackend } from "../../apis/notifications";
export class MytrumpfNotificationService {
    constructor() {
        this.debug = false;
        this.environment = "prod";
        this.clientId = undefined;
        this.clientName = undefined;
        this.pollInterval = undefined;
    }
    componentWillLoad() {
        const prod = !(this.environment === "qa" || this.environment === "dev");
        this.issuer = prod ? "https://identity.trumpf.com" : "https://identity-s.trumpf.com";
        initMyTrumpfNotificationBackend({
            environment: this.environment,
            authClientName: this.clientName,
            pollInterval: this.pollInterval,
            debug: this.debug
        });
    }
    render() {
        return (h(Host, { key: '65d82aa14b31e8b6bfacd6d093bd15b5512cf131' }, h("ux-u-silent-auth", { key: '52bbc1c4ecdd7a36f91e31881d129db5fc092cda', "client-id": this.clientId, "client-name": this.clientName, issuer: this.issuer, scope: "openid", debug: this.debug })));
    }
    static get is() { return "uxc-u-mytrumpf-notification-service"; }
    static get properties() {
        return {
            "debug": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Toggle debug mode"
                },
                "attribute": "debug",
                "reflect": false,
                "defaultValue": "false"
            },
            "environment": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"dev\" | \"prod\" | \"qa\"",
                    "resolved": "\"dev\" | \"prod\" | \"qa\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Environment used to select identity provider"
                },
                "attribute": "environment",
                "reflect": false,
                "defaultValue": "\"prod\""
            },
            "clientId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Auth client ID"
                },
                "attribute": "client-id",
                "reflect": false
            },
            "clientName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Auth client name if s scoped auth client should be used"
                },
                "attribute": "client-name",
                "reflect": false
            },
            "pollInterval": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Poll interval in ms"
                },
                "attribute": "poll-interval",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=mytrumpf-notification-service.js.map
